<template>
  <span>
    <h4>Список документов:</h4>
    <el-table
      v-loading="loadingContracts"
      :data="table"
      element-loading-text="Загрузка..."
      stripe
      style="width: 100%"
      max-height="500px"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
      @expand-change="expandSelect"
    >
      <el-table-column type="expand" width="20">
        <template slot-scope="props">
          <new-list-uploaded-files
            v-if="props.row.files.length > 0"
            :file-list="props.row.files"
            :is-signed="Boolean(props.row.is_signed)"
            type-document="contract"
            @getZip="getsZip(props.row.id)"
            @deleteOne="deleteOneFile"
          />
          <new-upload-files
            :docunent-id="props.row.id"
            :pasted-file="pastedFile"
            @uploaded="upload"
            @startUpload="onStartedUpload"
            @aborted="onAbort"
            @uploadImages="uploadImages"
          />
        </template>
      </el-table-column>
      <el-table-column label="№ документа" width="250">
        <template slot-scope="scope">
          <span
            v-if="showInputEditTitle && numberInputEditTitle === scope.row.id"
            style="display: flex; width: 170px"
          >
            <el-input
              v-model="scope.row.number"
              size="mini"
              style="margin-right: 4px"
            />
            <el-button
              :disabled="loadingContracts"
              :loading="loadingContracts"
              size="mini"
              type="success"
              icon="el-icon-check"
              plain
              @click="saveNumberHandle(scope.row.id, scope.row.number)"
            />
          </span>
          <span v-else @dblclick="editTitle(scope.row.id, scope.row.number)">
            <i class="el-icon-edit" />
            <span style="margin-left: 10px">
              {{ scope.row.number ? scope.row.number : 'Нет номера' }}
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Файлы" width="75">
        <template slot-scope="scope">
          <span style="margin-left: 10px">
            {{ scope.row.count_doc ? scope.row.count_doc : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Дата создания" width="205">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>Дата: {{ scope.row.date }}</p>
            <div slot="reference" class="name-wrapper" style="font-size: 14px">
              {{ scope.row.date }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="Cтатус" width="120">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span
              size="medium"
              type="info"
              style="width: 100px; text-align: center"
            >
              <span
                v-if="scope.row.is_current"
                style="color: #00bf40; width: 150px"
              >
                Актуальный <br />
              </span>
              <span
                v-if="scope.row.is_signed"
                style="color: #00bf40; width: 150px"
              >
                Подписан
              </span>
              <span
                v-if="!scope.row.is_signed"
                style="color: #f56c6c; width: 150px"
              >
                Не подписан
              </span>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Действия" width="400" align="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row['is_signed'] === 0"
            class="table-btn-custom"
            style="width: 120px"
            :loading="loadingContracts"
            :disabled="loadingContracts"
            size="mini"
            type="success"
            plain
            @click="signDocumentHandle(contractId, scope.row)"
          >
            Подписать
          </el-button>
          <el-button
            v-if="scope.row['is_signed'] === 1"
            type="danger"
            plain
            class="table-btn-custom"
            style="width: 120px"
            :loading="loadingContracts"
            :disabled="loadingContracts"
            size="mini"
            @click="signDocumentHandle(contractId, scope.row)"
          >
            Убрать подпись
          </el-button>
          <el-button
            class="table-btn-custom"
            style="width: 145px"
            :disabled="!!scope.row.is_current"
            size="mini"
            type="warning"
            plain
            @click="setActiveDocumentHandle(contractId, scope.row)"
          >
            Сделать актуальным
          </el-button>
          <el-button
            class="table-btn-custom"
            size="mini"
            type="danger"
            plain
            icon="el-icon-delete"
            :loading="loadingContracts"
            :disabled="loadingContracts"
            @click="
              () =>
                $emit('deleteDocument', {
                  contract_id: contractId,
                  doc_id: scope.row.id,
                })
            "
          />
        </template>
      </el-table-column>
    </el-table>
  </span>
</template>

<script>
import { fullDateWithTime } from '@/datas/DateFormats'
import { getDateOfCertainFormat } from '@/helpers/date'
import { kitcutText } from '@/helpers/functions'
import newListUploadedFiles from '@/components/Upload/newListUploadedFiles'
import newUploadFiles from '@/components/Upload/newUploadFiles'

export default {
  name: 'NewContractList',
  components: {
    newUploadFiles,
    newListUploadedFiles,
  },
  props: {
    loadingContracts: {
      type: Boolean,
      default: false,
    },
    pastedFile: {
      type: File,
      default: undefined,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    contractId: {
      type: Number || String,
    },
  },
  data() {
    return {
      expands: [],
      getRowKeys(row) {
        return row.id
      },
      currentDocument: null,
      showInputEditTitle: null,
      numberInputEditTitle: null,
    }
  },
  computed: {
    table() {
      return this.documents.map(document => ({
        number: document.number,
        date: getDateOfCertainFormat(document.created_at, fullDateWithTime),
        id: document.id,
        files: document.files,
        is_signed: document.is_signed,
        is_current: document.is_current,
        count_doc: document.files.length,
      }))
    },
  },
  methods: {
    expandSelect(row, expandedRows) {
      let that = this

      if (expandedRows.length) {
        that.expands = []

        if (row) {
          that.expands.push(row.id)
        }
      } else {
        that.expands = []
      }
    },
    saveNumberHandle(id, text) {
      this.$emit('saveNumber', { number: text, document_id: id })
      this.showInputEditTitle = null
      this.numberInputEditTitle = null
      this.currentDocument = null
    },
    editTitle(id) {
      this.currentDocument = null
      this.numberInputEditTitle = id
      this.showInputEditTitle = true
    },

    getsZip(id) {
      this.$emit('getZip', id)
    },
    deleteOneFile(data) {
      if (data.constructor === Array) {
        this.$confirm('Вы действительно хотите удалить все файлы?', 'Warning', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.$emit('deleteFile', data)
        })
      } else {
        this.$confirm(
          'Вы действительно хотите удалить файл ' + data + ' ?',
          'Warning',
          {
            confirmButtonText: 'Да',
            cancelButtonText: 'Нет',
            type: 'warning',
          },
        ).then(() => {
          this.$emit('deleteFile', [data])
        })
      }
    },
    onStartedUpload() {
      this.$emit('startUpload')
    },
    uploadImages(param1, param2) {
      this.$emit('uploadedImages', param1, param2)
    },
    upload(data) {
      this.$emit('uploaded', data)
    },
    onAbort() {
      this.$emit('aborted')
    },

    signDocumentHandle(contractId, document) {
      if (document?.files?.length === 0 && document.is_signed === 0) {
        this.$alert('Сначала загрузите договор', 'Ошибка', {
          confirmButtonText: 'OK',
        })

        return null
      }
      this.$emit('signDocument', {
        contract_id: contractId,
        doc_id: document.id,
        is_signed: document['is_signed'] === 0 ? 1 : 0,
      })
    },
    setActiveDocumentHandle(contractId, document) {
      this.$emit('setActiveDocument', {
        contract_id: contractId,
        doc_id: document.id,
      })
    },
    setNewCurrentDocument(id) {
      this.currentDocument = id
    },
    shortText(text) {
      return kitcutText(text, 29)
    },
  },
}
</script>

<style lang="sass">
.table-btn-custom
  text-align: center!important
  margin: 3px 8px 8px 0px!important
.contract-list
  margin-top: 25px
  .list-row
    border-bottom: 1px dotted #ccc
    padding-top: 8px
    padding-bottom: 8px
  .activeDocument
    color: #67C23A
    font-weight: 500
    margin-right: 18px
    margin-left: 4px
  .signed
    color: #67C23A
    font-weight: 500
    margin-right: 18px
    margin-left: 4px
    &-icon
      font-size: 24px
  .red
    color: #F56C6C
  & .item
    min-height: 25px
    & .btn-contract-delete
      opacity: 0
      cursor: pointer
    &:hover .btn-contract-delete
      opacity: 1
    & .name
      color: #9C9C9C
      position: relative
      &.active
        color: #E6A23C
      & .approved
        position: absolute
        left: -11px
        top: 6px
        width: 4px
        height: 4px
        background-color: #67C23A
        border-radius: 5px
  & .title
    display: block
    color: #000000
    margin-bottom: 10px
</style>
